import React from "react"
import Icon from "../../../../common/icon/icon.component.jsx"
import Image from "../../../../common/image/image.component.jsx"
import { FormattedMessage } from "react-intl"
import { getImageAlignment, getImageClassName } from "../text-and-image-row/helpers"
import { ImageContent } from "../text-and-image-row/types"


export interface ImageContentSectionProps {
    editable: boolean
    isPdf: boolean
    content: ImageContent
    section: {
        attributes: {
            internalName: string
        }
    }
}

const ImageContentSectionContent: React.FC<ImageContentSectionProps> = ({ editable, isPdf, content, section }) => {
    
    const hide = editable ? "" : "d-none"
    
    return (
        <div className={"py-2 col-12 "}>
            <div className={"row d-flex " + getImageAlignment({ alignment: content.alignment })}>
                {(content.image || content.imageId) ? 
                    <div className={getImageClassName({ size: content.size, isPdf: isPdf })} >
                        <Image
                            image={content.image}
                            imageId={content.imageId}
                            size={!isPdf ? "large" : "medium"}
                            linkUrl={content.linkUrl}
                            imageClassName={"w-100"}
                            isPdf={true} 
                        />
                    </div> 
                    :
                    <div className={"col-12 " + hide}>
                        <p className={"section-empty-message m-0 text-left"}>
                            {section.attributes.internalName}
                        </p>
                        <p className={"section-empty-message text-left"}>
                            <Icon value={"image"} />
                            <small className={"ml-2"}>
                                <FormattedMessage
                                    id="templates.sections.image.empty_message"
                                    defaultMessage="Image missing"
                                />
                            </small>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}

export { ImageContentSectionContent }






// WEBPACK FOOTER //
// ./src/template/sections/content/image/ImageContentSectionContent.tsx